import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

/**
 * Create Apollo Client instance for Odoo GraphQL API
 *
 * The client is configured to:
 * - Connect to Odoo GraphQL endpoint
 * - Include credentials (session cookies) for authentication
 * - Use in-memory cache for query results
 */
export function createApolloClient() {
  // In development, use relative URLs to go through Vite proxy
  // In production, use the configured ODOO_BASE_URL
  const odooBaseUrl =
    import.meta.env.MODE === 'development'
      ? '' // Use relative URLs in development (proxy will forward to localhost:8069)
      : import.meta.env.VITE_ODOO_BASE_URL || 'http://localhost:8069';

  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            node: {
              // Merge fields instead of replacing to prevent cache conflicts
              // when multiple queries fetch different fields of the same node
              merge(existing, incoming, { mergeObjects }) {
                return mergeObjects(existing, incoming);
              }
            }
          }
        }
      }
    }),
    defaultOptions: {
      mutate: {
        errorPolicy: 'all'
      },
      query: {
        errorPolicy: 'all',
        fetchPolicy: 'cache-first'
      },
      watchQuery: {
        errorPolicy: 'all',
        fetchPolicy: 'cache-and-network'
      }
    },
    link: new HttpLink({
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      uri: `${odooBaseUrl}/api/graphql`
    })
  });
}
